/**
 * Checks if the date format includes time tokens.
 * Case-sensitive: M (month) must NOT match — only m (minute) should.
 */
export const hasTimeFormat = (dateFormat: string): boolean => {
    return /[HhmsSaAzZxX]/.test(dateFormat);
};

